import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { AvailableExportCategories } from "./ExportCategories";

import styles from "./OntarioCommonDataSetExportForm.module.scss";

function CategoriesSelection(props: Readonly<{ selectedCategories: string[], onChange(categoriesToExport: string[]): void }>): JSX.Element {
    const { getText } = useTranslation();

    const updateSelection = (isChecked: boolean, exportCategoryKey: string): void => {
        const nextSelection = isChecked ? [...props.selectedCategories, exportCategoryKey] : props.selectedCategories.filter(item => item !== exportCategoryKey);
        props.onChange(nextSelection);
    };

    return (
        <div className={styles.categories}>
            <span className={styles.headerText}>{getText("SelectCategoriesToExportLabel")}</span>
            <div className={styles.exportCategoriesSection}>
                {AvailableExportCategories.map(p => (
                    <CheckboxControl
                        key={p.key}
                        label={getText(p.label)}
                        checked={props.selectedCategories.includes(p.key)}
                        onChange={isChecked => updateSelection(isChecked, p.key)}
                    />
                ))}
            </div>
        </div>
    );
}

export { CategoriesSelection };
